// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"816":"013920cb","985":"17c2807b"}[chunkId] + ".chunk.css";
};